import { Link, useLocation } from 'react-router-dom';
interface BreadcrumbProps {
  pageName: string;
  parentPage?: string;
  parentPath?: string;
  grandparentPage?: string;
  grandparentPath?: string;
  breadcrumbTitle?: string;
}
const Breadcrumb = ({ pageName, parentPage, parentPath, grandparentPage, grandparentPath, breadcrumbTitle }: BreadcrumbProps) => {
  const location = useLocation();

  return (
    <div className='mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
      <h1 className='text-title-md2 font-semibold text-black dark:text-white'>
        {pageName}
      </h1>

      <nav>
        <ol className='flex items-center gap-2'>
          <li>
            <Link to='/'>My Dashboard /</Link>
          </li>
          {grandparentPage && grandparentPath && (
            <li>
              <Link to={grandparentPath}>{grandparentPage} /</Link>
            </li>
          )}
          {parentPage && parentPath && (
            <li>
              <Link to={parentPath}>{parentPage} /</Link>
            </li>
          )}
          <li className='font-bold text-primary'>{breadcrumbTitle || pageName}</li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
